/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import ScrollToTop from "../../Utility/ScrollToTop/ScrollToTop";
import { Link, useNavigate } from "react-router-dom";
import menu1icon from "../../Assets/imgNewUI/1.svg";
import menu2icon from "../../Assets/imgNewUI/2.svg";
import offerhistory from "../../Assets/imgNewUI/offerhistory.png";
import menu3icon from "../../Assets/imgNewUI/3.png";
import HistoryMenu from "./HistoryMenu";
import {
  ApiConfigData,
  CustomFormatNumber,
  handleRedirectWithLoading,
  ModalOrSso,
  UtilityReducer,
  VoucherHistoryReducer,
} from "../../Utility/Utility";
import { useDispatch, useSelector } from "react-redux";
import { onGetVoucherHistory } from "../../Store/Slices/voucherHistorySlice";
import getTranslation from "../../TranslationUtility/TranslationUtility";
import Loader from "../../Utility/Loader/Loader";
import CustomBackHeader from "../../Utility/CustomBackHeader/CustomBackHeader";

const RewardPoint = ({ setIsLoading, Loading, login, setShowModal }) => {
  const dispatch = useDispatch();
  const translation = getTranslation();
  const isModal = ModalOrSso();
  const loginToken = useSelector(
    (state) => state.validateLoginTokenSliceReducer?.data?.memberIdentifier
  );

  const isVouchersHistory = useSelector((state) => state.homePageSliceReducer)?.homePageData?.isVouchersHistory;
  const [historyMenu, setHistoryMenu] = useState(false);
  const card = UtilityReducer();
  const currenPoints = CustomFormatNumber(Math.floor(card?.currentPoints));
  const totalPointBalance = CustomFormatNumber(
    Math.floor(card?.totalPointBalance)
  );
  const apiconfig = ApiConfigData();
  const karmaRedirectionUrl = apiconfig?.find(
    (data) => data?.paramsKey === "karmaRedirectionUrl"
  )?.paramsValue;

  const navigate = useNavigate();
  const apiConfigData = ApiConfigData();
  const integrationId = apiConfigData?.find(
    (data) => data?.paramsKey === "integrationId"
  )?.paramsValue;

  const loginUrl = `${process.env.REACT_APP_INTEGRATION_LOGIN_URL}Login/${integrationId}`;
  const myOfferBenefit = (data) => {
    if (data) {
      navigate(`/${data}`);
    } else {
      handleRedirectWithLoading(
        setIsLoading,
        karmaRedirectionUrl,
        login,
        setShowModal,
        isModal,
        navigate,
        loginUrl
      );
      sessionStorage.setItem("postLoginSuccesCount", 1);
    }
  };
  const selectcard = JSON.parse(sessionStorage.getItem("selectedCard"))?.card
    ?.identifiertype;
  return (
    <>
      <ScrollToTop />
        <div>
          <div className="row ">
            <CustomBackHeader
              title={translation?.rewardPoints}
            />
            {Loading ? (
              <></>
            ) : (
              <>
                <div className="reward-container">
                  {selectcard === "1002" ? (
                    <div className="total-point">
                      <h2>
                        {isNaN(parseInt(currenPoints)) ? 0 : currenPoints}
                      </h2>
                      <div className="subtitle">
                        {translation?.availableRewardPoints}
                      </div>
                    </div>
                  ) : (
                    <div className="flex w-90 justify-between re-card-b p-4">
                      <div className="flex-1">
                        <span className="re-span-1 block">
                          {isNaN(parseInt(currenPoints)) ? 0 : currenPoints}
                        </span>
                        <span className="re-span-2">
                          {translation?.redeemableRewardPoints}
                        </span>
                      </div>

                      <div className="reward-center-b"></div>

                      <div className="text-end flex-1">
                        <span className="re-span-1 block">
                          {" "}
                          {isNaN(parseInt(totalPointBalance))
                            ? 0
                            : totalPointBalance}
                        </span>
                        <span className="re-span-2">
                          {translation?.totalRewardPoints}
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="reward-link">
                    <ul>
                      {translation?.myOffersBenefits && <li onClick={() => myOfferBenefit("order-history")}>
                        <div className="link">
                          <img src={menu1icon} alt="" />{" "}
                          {translation?.myOffersBenefits}
                        </div>
                        <i className="fa-solid fa-angle-right mr-2"></i>
                      </li>}
                      {translation?.myOrdersAndBookings && <li onClick={() => setHistoryMenu(true)}>
                        <div className="link">
                          <img src={menu2icon} alt="" />{" "}
                          {translation?.myOrdersAndBookings}
                        </div>
                        <i className="fa-solid fa-angle-right mr-2"></i>{" "}
                      </li>}
                      {isVouchersHistory ? (

                        <li onClick={() => myOfferBenefit("voucher-history")}>
                          <div className="link">
                            <img src={offerhistory} alt="" />
                            <div className="flex flex-col  pt-1">
                              <span className="text-black">
                                {translation?.voucherHistory}
                              </span>
                              <span className="text-sm text-gray-500">
                                {translation?.valitTill}
                              </span>
                            </div>
                          </div>
                          <i
                            className="fa-solid fa-angle-right mr-2"
                            onClick={() => myOfferBenefit("voucher-history")}
                          />
                        </li>
                      ) : (
                        ""
                      )}
                      {card?.cardName?.toLowerCase() === "first private" && (
                        <li onClick={() => myOfferBenefit()}>
                          <div
                            className="link"

                          >
                            <img alt="alt-found" src={menu3icon} />{" "}
                            {translation?.karmaPoints}
                          </div>
                          <i
                            className="fa-solid fa-angle-right mr-2"
                          />
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      {/* )} */}
      {historyMenu && (
        <>
          <HistoryMenu
            login={login}
            setShowModal={setShowModal}
            apiconfig={apiconfig}
            setIsLoading={setIsLoading}
            Loading={Loading}
            title={"My Orders and Bookings"}
            onClose={() => setHistoryMenu()}
          />
        </>
      )}
    </>
  );
};
export default RewardPoint;
